import axios from "axios";
let clienteAxios = '';
clienteAxios = axios.create({
   baseURL: 'https://api.we-code.com.mx' 
});

// baseURL: 'http://localhost:5001'
//baseURL: 'https://api.we-code.com.mx' 
export default clienteAxios